import { Component } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FormBroadcast, FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { UserInfoService } from '../../../shared/services/user-info.service';
import { WholeHealthBalanceCrosswalk } from '../../../shared/components/configs/interfaces/whole-health-balance-and-agent-cube-state-structure.interface';
import { LOGIN_STRATEGY } from '@ptl/account-management';
import { WHOLE_HEALTH_BALANCE_CROSSWALK_STATE_NAME } from '../../../shared/components/configs/reducers/whb-crosswalk.reducer';

@FormComponentLookup('whb-consumer-login')
@Component({
    selector: 'app-whb-consumer-login',
    templateUrl: './whb-consumer-login.component.html',
    styleUrls: ['./whb-consumer-login.component.scss'],
    standalone: false
})
export class WhbConsumerLoginComponent extends FormEntryComponentClass {

  loginStrategy: LOGIN_STRATEGY = null;
  memberLoggedIn: boolean = false;
  memberEligible: boolean = false;
  baseEvent: FormBroadcast;

  protected userInfoService: UserInfoService;

  constructor() {
    super();
    this.userInfoService = this.injector.get(UserInfoService);
  }

  ngOnInit(): void {
    this.baseEvent = {
      formControlName: this.entry.formControlAttributes.formControlName,
      helperId: null,
      type: 'valueChange',
      value: 'not-eligible'
    };
    
    this.subscriptionGroup.push(this.userInfoService.isLoggedIn$.subscribe(isLoggedIn => {
      if (isLoggedIn) {
        this.memberLoggedIn = true;
        const whbInfo: WholeHealthBalanceCrosswalk = this.reducerUtilityService.getComponentStates()[WHOLE_HEALTH_BALANCE_CROSSWALK_STATE_NAME];
        
        if (whbInfo?.whbcrosswalk?.whbcrosswalk &&
            whbInfo.whbcrosswalk.newGroup &&
            whbInfo.whbcrosswalk.oldGroup) {
          this.memberEligible = true;
        }
        else {
          this.memberEligible = false;
          this.formStreamTrigger.triggerFormStream(this.baseEvent);
        }
      }
      else {
        this.memberLoggedIn = false;
      }
        
      const formControl: AbstractControl = this.formControls[this.entry.formControlAttributes.formControlName];
      formControl.updateValueAndValidity();
    }));

    // Set override for login strategy if provided
    this.loginStrategy = this.entry?.custom?.loginStrategy;
  }

  ngAfterViewInit(): void {
    const formControl: AbstractControl = this.formControls[this.entry.formControlAttributes.formControlName];
    
    formControl.setValidators((control: AbstractControl) => {
      return this.memberEligible ? null : {'notEligibleForWhb': true};
    });

    formControl.updateValueAndValidity();
    this.subscribeToFormStream(this.entry.base.formListeners);
  }
}
